/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CalendarEventResponseListResponse } from '../../models/calendar-event-response-list-response';

export interface GetFeV1Calendar$Plain$Params {

/**
 * The year (e.g., 2026).
 */
  year?: number;

/**
 * The month (1-12).
 */
  month?: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;

/**
 * Unique identifier for tracing the request across services
 */
  'X-Correlation-Id'?: string;
}

export function getFeV1Calendar$Plain(http: HttpClient, rootUrl: string, params?: GetFeV1Calendar$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendarEventResponseListResponse>> {
  const rb = new RequestBuilder(rootUrl, getFeV1Calendar$Plain.PATH, 'get');
  if (params) {
    rb.query('year', params.year, {});
    rb.query('month', params.month, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.header('X-Correlation-Id', params['X-Correlation-Id'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CalendarEventResponseListResponse>;
    })
  );
}

getFeV1Calendar$Plain.PATH = '/v1/calendar';
